import React, { useContext, useMemo } from 'react';
import { PharmacyPickerProvider } from '../../../../components/PharmacyPicker';
import { ChooseTreatmentContext } from '../FreeDosageLayoutV2';
import { getProductPriceForStock } from '../../helpersV2';

/*
  adapts the cannabis Choose Treatment context to the shared pharmacy picker context.

  The picker components used to read ChooseTreatmentContext directly. They were moved to
  components/PharmacyPicker so RX Self-Pickup can reuse them on the shipping page, and now read a
  narrow PharmacyPickerContext instead. This maps the cannabis values onto it — notably per-stock
  product pricing, which only cannabis has — so cannabis behaviour is unchanged.

  Mounted once inside each Choose Treatment layout's ChooseTreatmentContext.Provider, so every picker
  render site below it is covered.
*/
export const CannabisPharmacyPickerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const chooseTreatmentContext = useContext(ChooseTreatmentContext);
  const selectedProductForDetails = chooseTreatmentContext?.selectedProductForDetails;

  const value = useMemo(() => ({
    selectedService: chooseTreatmentContext?.selectedService,
    selectedStockCode: chooseTreatmentContext?.selectedStockCode,
    locale: chooseTreatmentContext?.cart?.locale_id || 'de-DE',
    getProductPriceForStock: (stockCode: string) => getProductPriceForStock(selectedProductForDetails, stockCode),
  }), [
    chooseTreatmentContext?.selectedService,
    chooseTreatmentContext?.selectedStockCode,
    chooseTreatmentContext?.cart?.locale_id,
    selectedProductForDetails,
  ]);

  return <PharmacyPickerProvider value={value}>{children}</PharmacyPickerProvider>;
};